import { WidgetConfig } from './types'
import { config } from '../../'

export default class Refinitiv {
  private static instance: Refinitiv

  private constructor() {
    window.dory.config.setBasePath('https://refinitiv-widgets.financial.com/')
  }

  public static get Instance(): Refinitiv {
    return this.instance || (this.instance = new this())
  }

  public async authenticate(): Promise<boolean> {
    if (!(await window.dory.ServiceAuth.isSessionValid())) {
      const response = await fetch(`${config.defaultWebApiUrl}/oauth/saml`, {
        credentials: 'include',
        mode: 'cors'
      })
      const samlResponse = await response.text()

      try {
        return await window.dory.ServiceAuth.samlLogin(
          '<?xml version="1.0" encoding="UTF-8"?>' + samlResponse
        )
      } catch (e) {
        return Promise.reject(`[Refinitiv]: ${e.message}`)
      }
    }

    return Promise.resolve(true)
  }

  public async initCompanyProfileWidget(
    selector: string,
    initialConfig?: WidgetConfig | null,
    initialLanguage?: string | null,
    localMessages?: Record<string, unknown> | null,
    themeName?: string
  ): Promise<void> {
    this.authenticate()
      .then(() => {
        window.fdc__widgets__.WCompanyProfile.init(
          selector,
          initialConfig,
          initialLanguage,
          localMessages,
          themeName
        )
      })
      .catch(err => {
        console.error(err)
      })
  }

  public async initEstimatesRatiosWidget(
    selector: string,
    initialConfig?: WidgetConfig | null,
    initialLanguage?: string | null,
    localMessages?: Record<string, unknown> | null,
    themeName?: string
  ): Promise<void> {
    this.authenticate()
      .then(() =>
        window.fdc__widgets__.WEstimatesRatios.init(
          selector,
          initialConfig,
          initialLanguage,
          localMessages,
          themeName
        )
      )
      .catch(err => {
        console.error(err)
      })
  }
}
